<template>
  <div class="secure-shell-form">
    <div class="field is-grouped">
      <div class="control">
        <input :value="value.user" @input="updateUser" placeholder="User" class="input" type="text" />
      </div>
      <div class="control">
        <p>@</p>
      </div>
      <div class="control">
        <input :value="value.host" @input="updateHost" placeholder="Host" class="input" type="text" />
      </div>
      <div class="control">
        <p>:</p>
      </div>
      <div class="control">
        <input :value="value.port" @input="updatePort" placeholder="Custom port" class="input" type="text" />
      </div>
    </div>
    <div class="field">
      <div class="control">
        <input :value="value.keyFile" @input="updateKeyFile" placeholder="Private key path e.g. ~/.ssh/id_rsa_custom" class="input" type="text" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'secure-shell-form',
  props: {
    value: { type: Object, required: true },
  },
  methods: {
    updateHost(event) {
      this.$emit('input', getUpdatedValue('host', event, this.value))
    },
    updateUser(event) {
      this.$emit('input', getUpdatedValue('user', event, this.value))
    },
    updatePort(event) {
      this.$emit('input', getUpdatedValue('port', event, this.value))
    },
    updateKeyFile(event) {
      this.$emit('input', getUpdatedValue('keyFile', event, this.value))
    }
  }
}

// helpers
function getUpdatedValue(key, event, initialValue) {
  return {
    ...initialValue,
    [key]: event.target.value || event.srcElement.value
  }
}


</script>


<style lang="scss" scoped>
.secure-shell-form {
  margin-bottom: 2rem;
}
</style>

